import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { ModalDialogActive } from '@ddv/common-components';
import { BaseConfigItem } from '@ddv/models';

@Component({
    selector: 'ddv-column-base-formatting',
    templateUrl: './column-base-formatting.component.html',
    styleUrls: ['../column-formatting-grid/column-formatting-grid.component.scss'],
    providers: [NgModel],
    standalone: false,
})
export class ColumnBaseFormattingComponent implements OnInit {
    @Input() parentData: BaseConfigItem | undefined;

    protected readonly modalDialogActive = inject(ModalDialogActive<BaseConfigItem>);
    private readonly fb = inject(FormBuilder);
    private readonly cdr = inject(ChangeDetectorRef);

    protected configForm: FormGroup | undefined;

    ngOnInit(): void {
        if (!this.parentData) {
            return console.error('Cannot initialize this component without parentData');
        }

        this.initForm(this.parentData);
        this.toggleCustomNameField();
    }

    protected toggleCustomNameField(): void {
        if (!this.configForm) {
            return;
        }

        if (this.configForm.controls.showCustomName.value) {
            this.configForm.controls.customName.enable();
        } else {
            this.configForm.controls.customName.disable();
        }
    }

    private initForm(data: BaseConfigItem): void {
        this.configForm = this.fb.group(
            {
                customName: [data.customName],
                showCustomName: [data.showCustomName],
            },
            {
                validators: (control: AbstractControl) => {
                    const formGroup = control;
                    const showCustomName = formGroup.get('showCustomName');
                    const customName = formGroup.get('customName');

                    if (!showCustomName || !customName) {
                        return null;
                    }

                    if (showCustomName.value) {
                        customName.setValidators(Validators.required);
                    } else {
                        customName.clearValidators();
                    }

                    return null;
                },
            },
        );
        this.cdr.detectChanges();
    }
}
